export type Child = Node | string | number | null | undefined | false | Child[];
type Attrs = Record<string, unknown> | null;

/** Tiny element builder: h("button", { class: "btn", onclick }, "Go"). */
export function h<K extends keyof HTMLElementTagNameMap>(tag: K, attrs?: Attrs, ...kids: Child[]): HTMLElementTagNameMap[K] {
  const el = document.createElement(tag);
  if (attrs) {
    for (const [k, v] of Object.entries(attrs)) {
      if (v == null || v === false) continue;
      if (k === "class") el.className = String(v);
      else if (k.startsWith("on") && typeof v === "function") el.addEventListener(k.slice(2), v as EventListener);
      else if (k === "value" && el instanceof HTMLInputElement) el.value = String(v);
      else el.setAttribute(k, v === true ? "" : String(v));
    }
  }
  const add = (c: Child) => {
    if (c == null || c === false) return;
    if (Array.isArray(c)) c.forEach(add);
    else el.append(c instanceof Node ? c : String(c));
  };
  kids.forEach(add);
  return el;
}

/** Flatten children into DOM nodes, dropping null/false. */
export function toNodes(kids: Child[]): Node[] {
  const out: Node[] = [];
  const add = (c: Child) => {
    if (c == null || c === false) return;
    if (Array.isArray(c)) c.forEach(add);
    else out.push(c instanceof Node ? c : document.createTextNode(String(c)));
  };
  kids.forEach(add);
  return out;
}

export const $ = <T extends HTMLElement = HTMLElement>(id: string): T => document.getElementById(id) as T;

export const reducedMotion = (): boolean => matchMedia("(prefers-reduced-motion: reduce)").matches;
